var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.703 9 7.79-7.819a.492.492 0 0 0 0-.703.492.492 0 0 0-.702 0L9 8.297 1.181.507a.492.492 0 0 0-.703 0 .492.492 0 0 0 0 .702L8.297 9l-7.79 7.819a.492.492 0 0 0 .337.844.519.519 0 0 0 .337-.141L9 9.703l7.79 7.819c.085.084.226.14.338.14a.492.492 0 0 0 .337-.844L9.704 9Z",
    fill: "#FFFDFC"
  })));
};
export default SvgClose;